import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import Modal from '@material-ui/core/Modal';
import AsignDay from './AsignDay';
import FormGenerateAgendaDaily from './FormGenerateAgendaDaily';
import moment from 'moment';
// pick a date util library
import "moment/locale/es";


const localizer = momentLocalizer(moment);

const DragAndDropCalendar = withDragAndDrop(Calendar);

const formats = {
  dayFormat: (date, culture) => localizer.format(date, 'DD', culture),
};

const CalendarComponent = ({ small, events: propEvents, dir, professional, dayStartSelect }) => {
    const [events, setEvents] = useState([]);
    const [event, setEvent] = useState();
    const [selectedDay, setDay] = useState(new Date(dayStartSelect));
    const [openAsignDay, setOpenAsignDay] = useState(false);
    const [dayEvents, setDayEvents] = useState([]);

    useEffect(()=>{
      loadEvents(new Date());
    },[]);

    
  const moveEvent = ({ event, start, end }) => {
    const idx = events.indexOf(event);
    const updatedEvent = { ...event, start, end };

    const nextEvents = [...events];
    nextEvents.splice(idx, 1, updatedEvent);

    setEvents(nextEvents);
  };

  const eventStyleGetter = (event) => {
    let color;

    switch (event.priority) {
      case 'high':
        color = '#fa697d';
        break;

      case 'family':
        color = '#4ce1b6';
        break;

      case 'non':
        color = '#70bbfd';
        break;
      default:
        color = '$color-additional';
        break;
    }

    const style = {
      backgroundColor: color,
      border: 'none',
    };

    return {
      style,
    };
  };

  const loadEvents = async (date) => {
    console.log(date);
    var dateCalendar = new Date(date);
    var dateStart = new Date(dateCalendar.getFullYear(), dateCalendar.getMonth(), 1);
    var dateEnd = new Date(dateCalendar.getFullYear(), dateCalendar.getMonth()+1, 0);

    var dataDate = {
                  f_inicio: moment(dateStart).format("YYYY/MM/DD"),
                  f_fin:  moment(dateEnd).format("YYYY/MM/DD"),
                  id: professional.id_agenda_activa
                }
    
                console.log(dataDate);
    try {
      const response = await fetch(process.env.REACT_APP_PUBLIC_URL + 'agenda/consultar',  {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'), 
        },
        body: JSON.stringify(dataDate)
      });

      if(response.status === 200){
        const data = await response.json();
        console.log(data);
        if(data.hasOwnProperty('contenido')){
          if(data.contenido instanceof Array ){
            var jornadas = data.contenido;
            jornadas.map((jornada)=>{
              jornada.start = new Date(jornada.start);
              jornada.end = new Date(jornada.end);
            });
            setEvents(jornadas);
          } else if (data.contenido instanceof String){
            console.log(data.contenido);
          }
        }
      }
      
    } catch (e){
      console.log(e);
    }
   
  }
const handleSelectSlot = () => {
    console.log("Selected day");
}
  return (
    <div className={`calendar${small ? ' calendar--small' : ''}`}>
        <DragAndDropCalendar
            rtl={dir === 'rtl'}
            localizer={localizer}
            events={events}
            views={['month']}
            popup
            formats={formats}
            step={60}
            timeslots={1}
            showMultiDayTimes
            onEventDrop={moveEvent}
            date={selectedDay}
            onNavigate={(date, view, action) => {
                console.log("select day specific", date , view, action);
                setDay(date);
                if(action === 'DATE'){
                  var dayEvent = events.filter(event=>{
                    console.log(event);
                    return moment(event.start).format('YYYY/MM/DD') === moment(date).format('YYYY/MM/DD');
                  });
                  setEvent(dayEvent[0]);
                  setDayEvents(dayEvent);
                  setOpenAsignDay(true)
                } else {
                  loadEvents(date);
                }                                
            }}
            onSelectEvent={handleSelectSlot}
            selectable={true}
            eventPropGetter={eventStyleGetter}
            messages={{
            previous: <span className="lnr lnr-chevron-left" />,
            next: <span className="lnr lnr-chevron-right" />,
            today: <span className="lnr lnr-calendar-full" />,
            }}
            components={{
              event: AsignDay
            }}
        />
        {openAsignDay? <Modal
                          open={openAsignDay}
                          onClose={()=>{
                            setOpenAsignDay(false);
                          }}
                          aria-labelledby="simple-modal-title"
                          aria-describedby="simple-modal-description"
                          style={{zIndex: 1000 }}
                        >
                            <div className="paperAppointment-flex">
                              <p>{selectedDay.toLocaleDateString()}</p>
                              <FormGenerateAgendaDaily selected_day={selectedDay} reload={loadEvents} professional={professional} event={event}/>
                            </div>
                        </Modal>: null}
    </div>)
};

CalendarComponent.propTypes = {
    events: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      allDay: PropTypes.bool,
      start: PropTypes.instanceOf(Date),
      end: PropTypes.instanceOf(Date),
      priority: PropTypes.string,
    })).isRequired,
    small: PropTypes.bool,
    dir: PropTypes.string.isRequired,
  };
  
  CalendarComponent.defaultProps = {
    small: false,
  };
  
  export default CalendarComponent;
  